/* eslint-disable complexity,max-statements */
import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { isNumber } from 'lodash';

import { configSelector } from 'shared/app/shell';
import { currentRouteSelector } from 'shared/app/state/selectors/routes';
import CaloriesDisclaimerTooltip from '../calories-disclaimer-tooltip';
import { usePdpContext } from '../../product-details-page/pdp-provider';

import styles from './styles.cssm';

const AuxiliaryProductInfo = () => {
  const { formatNumber, formats } = useIntl();
  const pdpShowCaloriesInHeader =
    useSelector(configSelector)?.pdpShowCaloriesInHeader;

  const {
    isDemystifyMenuPdpEnabled,
    isCustomizing,
    sizeInfo = {},
  } = usePdpContext();
  const { selectedSize, selectedSizeName } = sizeInfo || {};
  const { nutrition } = selectedSize || {};
  const location = useSelector(currentRouteSelector);
  const isNutritionPage = Boolean(location?.pathname?.includes('/nutrition'));

  const servingSize = nutrition?.servingSize?.displayValue;

  const caloriesValue = nutrition?.calories?.displayValue;
  const caloriesString = nutrition?.calories?.displayName;

  const showSizeInformation =
    (isCustomizing || isNutritionPage) && selectedSizeName && servingSize;
  const showCalorieInformation =
    pdpShowCaloriesInHeader &&
    (caloriesValue || caloriesValue === 0) &&
    caloriesString;

  const totalAmount =
    isDemystifyMenuPdpEnabled && isNumber(sizeInfo.selectedSizeBasePrice)
      ? formatNumber(sizeInfo.selectedSizeBasePrice, formats.number.money)
      : '';

  const productSizeInfo =
    selectedSizeName?.trim() === servingSize?.trim()
      ? selectedSizeName
      : `${selectedSizeName} ${servingSize}`;
  return (
    <React.Fragment>
      {showSizeInformation && (
        <div
          className={`flex items-center color-textWhiteSoft mt2 ${styles.auxiliaryProductInfoFont}`}
        >
          <span>{productSizeInfo}</span>
        </div>
      )}
      <div
        className={`flex items-center color-textWhiteSoft mt2 ${styles.auxiliaryProductInfoFont}`}
      >
        {totalAmount && <span data-e2e="product-price">{totalAmount}</span>}
        {totalAmount && showCalorieInformation && <span>&nbsp;|&nbsp;</span>}
        {showCalorieInformation && (
          <React.Fragment>
            <span data-e2e="calories">{caloriesValue}</span>
            <span className={'pl1'}>{caloriesString.toLowerCase()}</span>
            <CaloriesDisclaimerTooltip
              innerClassName={styles.caloriesIconWrapper}
            />
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};

export default AuxiliaryProductInfo;
